export class UserMeta {
    public UserRecNo: KnockoutObservable<number> = ko.observable(null);
    public UserRoleRecNo: KnockoutObservable<number> = ko.observable(null);
    public AcctRecNo: KnockoutObservable<number> = ko.observable(null);
    public CustomerID: KnockoutObservable<string> = ko.observable(null);
    public UserID: KnockoutObservable<string> = ko.observable(null);
    public isImpersonating: KnockoutObservable<boolean> = ko.observable(false);
    public OriginalUsername: KnockoutObservable<string> = ko.observable(null);

    public GetUserMetaData = () => {
        let self = this;

        console.info("Retrieving user meta data...")
        let promise = new Promise((resolve, reject) => {
            $.getJSON('/MyAccount/WhoAmI', function (data) {
                
                if (data === "Error: Not logged in") {
                    // Return default self anyway
                    return resolve(self);
                }

                self.UserRecNo(parseInt(data.opUserRecNo));
                self.UserRoleRecNo(parseInt(data.opUserRoleRecNo));
                self.AcctRecNo(parseInt(data.AcctRecNo));
                self.CustomerID(data.CustomerID);

                self.UserID(data.opUserID);
                self.isImpersonating(data.isImpersonating);
                self.OriginalUsername(data.OriginalUsername);
                return resolve(self);
            });
        });

        return promise;
    };

    constructor(model?) {
        let self = this;
        if (model) {
            self.UserRecNo(parseInt(model.UserRecNo));
            self.UserRoleRecNo(parseInt(model.UserRoleRecNo));
            self.AcctRecNo(parseInt(model.AcctRecNo));
            self.CustomerID(model.CustomerID);

            self.UserID(model.UserID);
            self.isImpersonating(model.isImpersonating);
            self.OriginalUsername(model.OriginalUsername);
        }
        else {
            self.GetUserMetaData().then((result) => {
                console.debug("User meta data retrieved", result);

            });            
        }
    }
}